<template>
    <div class="page bgF6F6F6">

        <header class="pageHeader paddingH16 paddingV8 white_bg">
            <div class="borderLayout">
                <div class="middleRegion" style="line-height: 30px;">
                    <div class="westRegion" style="width: 60px">
                        <router-link to="/auth/kindergartenAuth" class="icon leftAngleBracketIcon floatL"
                             style="margin-top: 4px;"></router-link>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion alignRight" style="width: 60px">
                        <router-link class="font13r grey" :to="{name : 'kindergartenAuthHelp'}">帮助</router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="body" style="padding-bottom: 34px;">

            <form action="javascript:;" @submit="submit()">
                <div class="paddingH10">
                    <div class="paddingH4 paddingV12 red font14r" style="line-height: 19px;">
                        园所认证仅面向真实园所开放，认证前需要进行认证审核您保证您填写的信息真实有效。
                    </div>
                </div>

                <div class="paddingH10 white_bg">
                    <div class="formRow">
                        <div class="columnName">园所全称</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" required="" v-model="formData.name" />
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">省市区</div>
                        <div class="columnValue alignR" @click="areaSelectingPopup.visible = true">
                            {{areaSelectingPopup.fieldValue ? areaSelectingPopup.fieldValue : '选择'}}
                            <i class="fa fa-angle-right"></i>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">详细地址</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" required="" v-model="formData.addr" />
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">园所类型</div>
                        <div class="columnValue alignR">
                            <dictSelect module="kindergarten_type" v-model="formData.schoolType"
                                selectStyle="border: solid 1px #BBBBBB; background: transparent" />
                        </div>
                    </div>
                </div>

                <div class="paddingH10 white_bg" style="margin-top: 20px;">
                    <div class="formRow">
                        <div class="columnName">申请人身份</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="请输入您的身份" required=""
                                   v-model="formData.applyPosition"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">园长姓名</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="请输入园长的名字" required=""
                                   v-model="formData.corporateName"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">园所手机</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="请输入园长的手机号" required=""
                               v-model="formData.phone"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">验证码</div>
                        <div class="columnValue alignR">
                            <phoneVerificationCodeInputbox :phone="formData.phone" :length="6" placeholder="验证码"
                                :required="true" v-model="formData.verificationCode"/>
                        </div>
                    </div>
                </div>

                <div class="paddingH10 white_bg" style="margin-top: 20px;">
                    <div class="paddingV12" style="margin-top: 20px;">
                        <div class="clearfix">请上传认证材料
                            <span class="floatR grey font13r">{{formData.certificationImgs.length}}/5</span>
                        </div>
                        <div class="marginT8 font13r">
                            <span class="red">办园资质</span>/园所门头照/官方图片等
                        </div>
                        <div class="marginT8">
                            <imageListSelector v-model="formData.certificationImgs" :maxLength="5" />
                        </div>
                    </div>
                    <div class="clearfix paddingV12" style="margin-top: 20px;">
                        <div>请上传园所LOGO
                            <span class="grey marginL12 font13r">（用做平台头像）</span>
                        </div>
                        <div class="marginT8">
                            <headImageSelector v-model="formData.headImage" />
                        </div>
                    </div>
                </div>

                <div class="paddingH10 white_bg" style="margin-top: 20px;">
                    <div class="paddingT12">园所介绍</div>
                    <div class="marginT12 paddingB12">
                    <textarea type="text" class="inputbox block"
                              style="min-height: 150px; border-color: #BBBBBB;" v-model="formData.introduce" required=""></textarea>
                    </div>
                </div>

                <div class="marginT16" style="padding: 0 24px; line-height: 18px;">
                    <label class="inline font12r lightgrey">
                        <input type="checkbox" class="orangeCircleTickCheckbox"
                           style="vertical-align: middle; margin-top: -1px;" v-model="agreeProtocol"/>
                        阅读并同意师讯平台
                    </label>
                    <router-link to="/help/agreement/kindergarten_agreement" class="orange font12r">《园所认证须知》</router-link>
                </div>

                <div class="marginT8" style="padding: 0 24px;">
                    <button class="submitButton block alignC font14r" type="submit">确认提交</button>
                </div>
            </form>

        </div><!-- end .body -->

        <van-popup v-model="areaSelectingPopup.visible" round position="bottom">
            <van-cascader
                v-model="areaSelectingPopup.cascaderValue"
                title="请选择所在地区"
                :options="areaSelectingPopup.options"
                @close="areaSelectingPopup.visible = false"
                @finish="onChangeArea"
            />
        </van-popup>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import Vue from 'vue';
import {field, popup, cascader } from 'vant';
Vue.use(field);
Vue.use(popup);
Vue.use(cascader);
import headImageSelector from '@/components/headImageSelector';
import imageListSelector from '@/components/imageListSelector';
import phoneVerificationCodeInputbox from '@/components/phoneVerificationCodeInputbox';
import dictSelect from '@/components/dict/dictSelect';

// config and data
import appConfig from '@/appConfig';
import citiesList from '@/data/citiesList_v3'

// util
import appHelper    from '@/util/appHelper';
import consoleApi   from '@/components/platformApi/consoleApi';

const config = {
    name : 'kindergartenAuthForm',
    title : '申请开通园所',
    description : '',
    apiConfig : {
        add : {
            url : 'portal/underline/v2/kindergarten/apply',
            method : 'POST'
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { headImageSelector, imageListSelector, phoneVerificationCodeInputbox, dictSelect },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            formData : {
                name : '',
                province : '',
                city : '',
                area : '',
                addr : '',
                schoolType : '',
                applyPosition : '',
                corporateName : '',
                phone : '',
                verificationCode : '',
                certificationImgs : [],
                headImage : '',
                introduce : '',
            },

            agreeProtocol : false,

            areaSelectingPopup : {
                visible : false,
                options : citiesList,
                fieldValue : '',
                cascaderValue : ''
            }
        }
    },
    methods : {
        onChangeArea({ selectedOptions }) {
            this.areaSelectingPopup.visible = false;
            this.formData.province = selectedOptions[0].value;
            this.formData.city = selectedOptions[1].value;
            this.formData.area = selectedOptions[2].value;
            this.areaSelectingPopup.fieldValue = selectedOptions.map((option) => option.text).join('/');
        },
        submit() {
            consoleApi.log('[submit] form data:');
            consoleApi.log(this.formData);

            if (this.formData.companyType == '' || this.formData.province == '' ||
                this.formData.city == '' || this.formData.area == '' || this.formData.headImage == '' ||
                this.formData.certificationImgs.length < 1 )
            {
                appHelper.showHint('请填完完整信息');
                return;
            }

            if (!this.agreeProtocol)
            {
                appHelper.showHint('请阅读并勾选同意《主办方认证须知》');
                return;
            }

            this.updateDataItem(this.formData);
            this.save();
        },
        beforeSubmit(data) {
            data.certificationImgs = JSON.stringify(data.certificationImgs);
            return data;
        },
        onSubmitSuccess() {
            appHelper.showHint('提交成功');
            appHelper.goToPage('kindergartenAuthSubmitSuccess');
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #F42418;
}
.orange {
    color: #FFB84D;
}
.grey {
    color: #777777;
}
.lightgrey {
    color: #B8C2D6;
}

.formRow {
    display: flex;
    padding: 8px 0;
    .columnName {
        width: 90px;
        color: #101010;
    }
    .columnValue {
        flex: 1;
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: solid 1px #BBBBBB;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
        .selectbox {
            border: solid 1px #BBBBBB;
            height: 27px;
            line-height: 27px;
            min-width: 120px;
            background: white;
        }
    }
}
.submitButton {
    display: block;
    width: 100%;
    padding: 0;
    background: #FFB946;
    color: white;
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    border: none;
}
</style>
